// Links from the former flow experiment (`/v1/...`, `/v3/...`, `/v4/...`) open
// the same page now that every user is in the chat: Sumsub, bank card,
// email and SMS links sent before still land.
const LEGACY_FLOW_PREFIX = /^\/v[134](?=\/|$)/;

export const stripLegacyFlowPrefix = (): void => {
  const { pathname, search, hash } = window.location;
  if (!LEGACY_FLOW_PREFIX.test(pathname)) {
    return;
  }

  const path = pathname.replace(LEGACY_FLOW_PREFIX, '') || '/';
  window.history.replaceState(window.history.state, '', `${path}${search}${hash}`);
};
